import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TableRowWidget", {
  title: "Table Row",
  titleForContent: () => "Row",
  properties: ["verticalAlignment"],
});
